import { render, staticRenderFns } from "./AppSettingsItem.vue?vue&type=template&id=e95bcfb0&"
import script from "./AppSettingsItem.vue?vue&type=script&lang=js&"
export * from "./AppSettingsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports